var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckDouble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.356 5.44193C13.6 5.10724 13.5266 4.63809 13.1919 4.39405C12.8572 4.15 12.388 4.22349 12.144 4.55817L7.76899 10.5582C7.52495 10.8929 7.59843 11.362 7.93312 11.6061C8.26781 11.8501 8.73696 11.7766 8.98101 11.4419L13.356 5.44193ZM10.356 5.44198C10.6 5.1073 10.5266 4.63814 10.1919 4.3941C9.85719 4.15006 9.38804 4.22354 9.14399 4.55823L5.28011 9.85726L3.27483 7.89291C2.97894 7.60305 2.50409 7.60794 2.21423 7.90384C1.92437 8.19974 1.92927 8.67459 2.22517 8.96444L4.85017 11.5359C5.00578 11.6883 5.21997 11.7656 5.43706 11.7475C5.65414 11.7295 5.85267 11.618 5.98101 11.442L10.356 5.44198Z",
    fill: "#A614B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckDouble);
export default __webpack_public_path__ + "static/media/icon-check-double.0e203163abd0d10c05075c12a2a2cf05.svg";
export { ForwardRef as ReactComponent };